/**
 * Icons mappings to be retrocompatible with iCherche
 */
export const ICHERCHE_ICONS: Record<string, string> = {
  'airplane-marker': 'travel',
  ambulance: 'ambulance',
  'baby-face-outline': 'child_care',
  bank: 'account_balance',
  'book-open-variant': 'menu_book',
  'circle-slice-8': 'circle_circle',
  city: 'location_city',
  engine: 'charger',
  'fire-truck': 'fire_truck',
  'flag-triangle': 'flag',
  flash: 'flash_on',
  home: 'home',
  'home-account': 'location_home',
  'home-city': 'home_work',
  hospital: 'local_hospital',
  'map-legend': 'grid_on',
  'map-marker': 'location_on',
  'map-marker-alert': 'fmd_bad',
  'map-marker-multiple': 'local_post_office',
  'map-marker-radius': 'pin_drop',
  'map-search': 'map_search',
  'office-building': 'apartment',
  'panorama-horizontal': 'panorama',
  parking: 'local_parking',
  pharmacy: 'local_pharmacy',
  'police-badge-outline': 'local_police',
  'road-variant': 'road',
  'scale-balance': 'balance',
  school: 'school',
  'table-picnic': 'rest_area',
  tent: 'camping',
  terrain: 'landscape',
  train: 'train',
  tree: 'nature',
  'vector-union': 'location_city',
  waterfall: 'waves',
  waves: 'waves'
};
